module.exports = __webpack_public_path__ + "img/1200.d920b2c0.jpg";